/**
 * Les modeles que le proprietaire peut choisir pour Lia (Parametres > IA). Source
 * unique : le shell affiche cette liste, le serveur ne sert que ces identifiants
 * (le bundle des Functions l'embarque, voir `functions/build-studio.mjs`).
 *
 * Chaque modele a ete joue sur la recette de Lia avec le zero retention force
 * (`provider.zdr`, `provider.data_collection: deny`) : appels d'outils, francais,
 * Markdown. Le prix et la vitesse sont indicatifs, mesures sur cette recette ; la
 * PR qui ajoute ou retire un modele porte la mesure. GPT-6 Luna reste dans Jev
 * (protege par le repli) mais pas dans le menu : sature en amont (429) une demande
 * sur deux lors de la mesure du 30/09, et des appels d'outils rates. Qwen 3.8 27B
 * gratuit : un seul hebergeur (ModelRun), plafond de debit partage entre tous ses
 * utilisateurs ; sature ou muet 25 s, il passe la main a DeepSeek (`model.ts`), et
 * son libelle le dit : le choix affiche ne promet pas que Qwen repond.
 * Mesure du 01/10/2026 : 4 demandes sur 5 servies par Qwen lui-meme, 10 a 25 s.
 */
export interface LiaModelChoice {
  /** Identifiant OpenRouter, ou `auto` pour Jev. */
  id: string;
  label: string;
  /** Cout indicatif d'une demande courante. */
  price: string;
  /** Temps de reponse indicatif d'une demande courante. */
  speed: string;
  /** Hebergeurs sans retention constates. */
  hosts: string;
}

/** Le routeur Jev : il choisit, a chaque tour, l'un des modeles de `LIA_JEV_MODELS`. */
export const LIA_MODEL_AUTO = 'auto';

/** Modele de Lia quand l'org n'a rien choisi et que le serveur ne fixe pas `TAKI_AI_MODEL`. */
export const LIA_MODEL_DEFAULT = 'deepseek/deepseek-v4.1-flash';

/** Les seuls modeles que Jev peut choisir : tous rapides, tous servis sans retention. */
export const LIA_JEV_MODELS: readonly string[] = [
  'deepseek/deepseek-v4.1-flash',
  'google/gemini-3.8-flash',
  'openai/gpt-6-luna',
];

export const LIA_MODEL_CHOICES: readonly LiaModelChoice[] = [
  { id: 'deepseek/deepseek-v4.1-flash', label: 'DeepSeek V4.1 Flash', price: 'environ 0,002 $ par demande', speed: 'rapide (5 à 8 s)', hosts: 'Together, DeepInfra, Wafer…' },
  { id: 'google/gemini-3.8-flash', label: 'Gemini 3.8 Flash', price: 'environ 0,01 $ par demande', speed: 'moyen (10 s)', hosts: 'Google Vertex' },
  { id: 'anthropic/claude-haiku-4.5', label: 'Claude Haiku 4.5', price: 'environ 0,02 $ par demande', speed: 'moyen (10 à 15 s)', hosts: 'Amazon Bedrock' },
  { id: 'qwen/qwen3.8-27b:free', label: 'Qwen 3.8 27B gratuit, ou DeepSeek', price: '0 $', speed: 'lent (10 à 25 s), souvent saturé', hosts: 'ModelRun ; DeepSeek prend le relais quand il est saturé ou trop lent' },
  { id: LIA_MODEL_AUTO, label: 'Automatique (Jev, bêta)', price: 'environ 0,003 $ par demande', speed: 'rapide (5 à 8 s)', hosts: 'selon le modèle choisi par Jev' },
];

/** Un choix inconnu (ancien modele retire, valeur forgee) retombe sur le defaut. */
export function liaModelChoice(value: unknown): string | null {
  return typeof value === 'string' && LIA_MODEL_CHOICES.some((choice) => choice.id === value) ? value : null;
}
